export default {
	plants: [],
	useYnList: [],
	gridUseYnList: [],
	searchParams: {
		plantCd: '',
		userGrpName: null,
		userName: null,
		useYn: null
	},
	resultList: [],
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	},
	selectedRow: {
		permGrpCd: '',
		userGrpName: '',
		useYn: ''
	}
};
